const NotAuthorized = () => (
  <div style={{ textAlign: 'center', marginTop: 80 }}>
    <h2>⛔ دسترسی غیرمجاز</h2>
    <p>شما اجازه دسترسی به این صفحه را ندارید.</p>
  </div>
);

export default NotAuthorized;
